<div class="cw-global-header-icon" (click)="showHelp()">
    <span class="cw-global-help-icon icon-help"></span>
</div>
